import styled from 'styled-components';

import { PaginationVariant } from './types';
import { PageButtons } from './PageButtons';
import { ArrowButton } from './ArrowButton';

const PaginationGroup = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  /** Function to run when a page number is selected. */
  onChangePage: (page: number) => void;
  /** Number of pages. */
  pages: number;
  /** Currently selected page. */
  page: number;
  /** Max number of page buttons to display. */
  maxPages?: number;
  /** Color themes */
  variant?: PaginationVariant;
};

export const Pagination = ({
  onChangePage,
  pages,
  page,
  maxPages = 7,
  variant = PaginationVariant.Purple,
  ...props
}: Props) => (
  <PaginationGroup data-test="pagination-buttons" {...props}>
    <ArrowButton
      direction={'left'}
      page={page}
      pages={pages}
      onChangePage={onChangePage}
      pageVariant={variant}
    />
    <PageButtons
      page={page}
      pages={pages}
      onChangePage={onChangePage}
      maxPages={maxPages}
      pageVariant={variant}
    />
    <ArrowButton
      direction={'right'}
      page={page}
      pages={pages}
      onChangePage={onChangePage}
      pageVariant={variant}
    />
  </PaginationGroup>
);

export default Pagination;
